import { cn } from "@/lib/utils";

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn("bg-ds-neutral-100 dark:bg-ds-neutral-800 animate-pulse rounded-md", className)} {...props} />
  );
}

export { Skeleton };
